import { Controller, Menu } from '@tencent/workbench';
import { VipLinkTextFeature } from './vip-link-text-feature';
import { INSERT_TEXT_MENU_CONFIGS, config } from './config';
import { getVipLinkText } from '@src/framework/frame-pc/components/vip-link-text';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
})
export class VipLinkTextController {
    public constructor(private readonly feature: VipLinkTextFeature) {
    }

    @Menu(config.id, 'content')
    public getContent() {
        return getVipLinkText(true);
    }
}
